module.exports = __webpack_public_path__ + "static/img/14.b686d9e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/12/sp/14.png
// module id = cu9O
// module chunks = 0